import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@mui/styles';
import CardPerformanceBlock from 'components/candidate_cards/CandidateCardWrapper/CardPerformanceBlock';
import ScoreContainer from '../../ScoreContainer';

import Achivements from './Achivements';
import styles from './styles';


const CardScoreBlock = ({
    candidate, propPublic, classes, showOverallRank, showPerformance, showPercentage
}) => {
    const { achievements, archived } = candidate;

    if (archived) return null;

    return (
        <div className={classes.wrapper}>
            <div className={classes.innerWrapper}>
                {
                    showPerformance && <CardPerformanceBlock candidate={candidate} showOverallRank={showOverallRank} />
                }
                <div className={classes.scoreWrapper}>
                    <ScoreContainer candidate={candidate} propPublic={propPublic} showPercentage={showPercentage} />
                </div>
            </div>
            {
                achievements && <Achivements achievements={achievements} />
            }
        </div>
    );
};

export default withRouter(withStyles(styles)(CardScoreBlock));
